import React from "react";
import styled from "styled-components";
import MainMenu from "../Components/Main_Menu";
import ProfileHeader from "../Components/ProfileHeader";
import Search from "./Search";
import ProfileBody from "../Components/ProfileBody";

const Proflie = () => {
  return (
    <>
      <ProflieWrap>
        <MainMenu />
        <ProflieContentWrap>
          <ProfileHeader />
          <ProfileBody />
        </ProflieContentWrap>
        <Search />
      </ProflieWrap>
    </>
  );
};

export default Proflie;

const ProflieWrap = styled.div`
  width: 100%;
  padding-bottom: 40px;
  /* margin-bottom: 40px; */
  background-color: #efefef;

  @media (max-width: 767px) {
    margin-top: 40px;
    /* margin-bottom: 60px; */
    padidng-bottom: 60px;
  }
`;

const ProflieContentWrap = styled.div`
  width: calc(100% - 240px);

  position: relative;
  left: 120px;
  margin: 0 auto;

  @media (max-width: 1264px) {
    width: calc(100% - 80px);

    left: 40px;
  }

  @media (max-width: 767px) {
    width: 100%;
    left: 0;
  }
`;
